import { datesAreOnSameDay } from '.';

/**
 * Returns true if date A is the day before date B.
 * @param dateA: a Date
 * @param dateB: another Date
 */
export const datesAreConsecutive = (dateA: Date, dateB: Date): boolean => {
    const dayAfterDateA = new Date(dateA);

    dayAfterDateA.setDate(dateA.getDate() + 1);

    return datesAreOnSameDay(dayAfterDateA, dateB);
};
